import { useDialog } from "@platform/store";
import { SchedulingDialog } from "@platform/features/programScheduling";
import { useProgram } from "@platform/hooks/useProgram";

export function ProgramScheduleFormContainer() {
  const { program } = useProgram();
  const { activeDialog, closeDialog, dialogProps } = useDialog();

  const isOpen = activeDialog === "scheduling";

  const handleDone = async () => {
    // close the dialog
    closeDialog();
  };

  if (!program) return null;

  return (
    <SchedulingDialog
      onDone={handleDone}
      onClose={handleDone}
      isOpen={isOpen}
      programId={program.id}
      userPhaseActionId={dialogProps?.userPhaseActionId as number}
      scheduledEngagementStartDate={program.scheduled_engagement_start_date ?? undefined}
    />
  );
}

export default ProgramScheduleFormContainer;

